import { render } from "./ItemList.vue?vue&type=template&id=5381c8ee"
import script from "./ItemList.vue?vue&type=script&lang=ts"
export * from "./ItemList.vue?vue&type=script&lang=ts"
script.render = render

export default script